import * as types from
    "./types";


import {
    register,
    login,
    verifyOtp,
    passwordReset,
    confirmPasswordReset,
    updateUserProfile,
    changePassword,
    requestAccountDeletion
} from "../../services/authService";

export const registerAction =
    (payload) =>
    async (
        dispatch
    ) => {
        dispatch({
            type:
                types.REGISTER_REQUEST,
        });

        const result =
            await register(
                payload
            );

        if (
            result.success
        ) {
            dispatch({
                type:
                    types.REGISTER_SUCCESS,
                payload:
                    result.data,
            });
        } else {
            dispatch({
                type:
                    types.REGISTER_FAILURE,
                payload:
                    result.error,
            });
        }

        return result;
    };

export const loginAction =
    (
        username,
        password
    ) =>
    async (
        dispatch
    ) => {
        dispatch({
            type:
                types.LOGIN_REQUEST,
        });

        const result =
            await login(
                username,
                password
            );

        if (
            result.success
        ) {
            dispatch({
                type:
                    types.LOGIN_SUCCESS,
                payload:
                    result.data,
            });
        } else {
            dispatch({
                type:
                    types.LOGIN_FAILURE,
                payload:
                    result.error,
            });
        }

        return result;
    };

export const verifyOtpAction =
    (
        payload
    ) =>
    async (
        dispatch
    ) => {
        dispatch({
            type:
                types.VERIFY_OTP_REQUEST,
        });

        const result =
            await verifyOtp(
                payload
            );

        if (
            result.success
        ) {
            dispatch({
                type:
                    types.VERIFY_OTP_SUCCESS,
                payload:
                    result.data,
            });
        } else {
            dispatch({
                type:
                    types.VERIFY_OTP_FAILURE,
                payload:
                    result.error,
            });
        }

        return result;
    };

export const passwordResetAction =
    (
        email
    ) =>
    async (
        dispatch
    ) => {
        dispatch({
            type:
                types.PASSWORD_RESET_REQUEST,
        });

        const result =
            await passwordReset(
                email
            );

        if (
            result.success
        ) {
            dispatch({
                type:
                    types.PASSWORD_RESET_SUCCESS,
                payload:
                    result.data,
            });
        } else {
            dispatch({
                type:
                    types.PASSWORD_RESET_FAILURE,
                payload:
                    result.error,
            });
        }

        return result;
    };

export const confirmPasswordResetAction =
    (
        payload
    ) =>
    async (
        dispatch
    ) => {
        dispatch({
            type:
                types.PASSWORD_RESET_CONFIRM_REQUEST,
        });

        const result =
            await confirmPasswordReset(
                payload
            );

        if (
            result.success
        ) {
            dispatch({
                type:
                    types.PASSWORD_RESET_CONFIRM_SUCCESS,
                payload:
                    result.data,
            });
        } else {
            dispatch({
                type:
                    types.PASSWORD_RESET_CONFIRM_FAILURE,
                payload:
                    result.error,
            });
        }

        return result;
    };

export const updateProfileAction =
    (
        profileData
    ) =>
    async (
        dispatch
    ) => {
        dispatch({
            type:
                types.UPDATE_PROFILE_REQUEST,
        });

        const result =
            await updateUserProfile(
                profileData
            );

        if (
            result.success
        ) {
            dispatch({
                type:
                    types.UPDATE_PROFILE_SUCCESS,
                payload:
                    result.data,
            });
        } else {
            dispatch({
                type:
                    types.UPDATE_PROFILE_FAILURE,
                payload:
                    result.error,
            });
        }

        return result;
    };

export const changePasswordAction =
    (
        currentPassword,
        newPassword
    ) =>
    async (
        dispatch
    ) => {
        dispatch({
            type:
                types.CHANGE_PASSWORD_REQUEST,
        });

        const result =
            await changePassword(
                currentPassword,
                newPassword
            );

        if (
            result.success
        ) {
            dispatch({
                type:
                    types.CHANGE_PASSWORD_SUCCESS,
                payload:
                    result.data,
            });
        } else {
            dispatch({
                type:
                    types.CHANGE_PASSWORD_FAILURE,
                payload:
                    result.error,
            });
        }

        return result;
    };

export const requestAccountDeletionAction =
    () => async dispatch => {
        dispatch({
            type:
                types.REQUEST_ACCOUNT_DELETION_REQUEST,
        });

        const result =
            await requestAccountDeletion();

        if (
            result.success
        ) {
            dispatch({
                type:
                    types.REQUEST_ACCOUNT_DELETION_SUCCESS,
                payload:
                    result.data,
            });

            return {
                success: true,
                data:
                    result.data,
            };
        }

        dispatch({
            type:
                types.REQUEST_ACCOUNT_DELETION_FAILURE,
            payload:
                result.error,
        });

        return {
            success: false,
            error:
                result.error,
        };
    };

export const logoutAction = () => dispatch => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");

    dispatch({
        type: types.LOGOUT,
    });
};